/**
 * PasswordInput — Champ mot de passe avec œil toggle afficher/masquer.
 *
 * Règle doctrine 0-quater DECISIONS.md : mobile-first. Zone de touch 44 px.
 * Utilisé sur Login, Reset, AcceptInvitation, Account (change mdp).
 *
 * Props : identiques à `Input` Shadcn, sauf que `type` est forcé.
 * Expose `data-testid` pour pouvoir cibler l'œil en test.
 */
import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = forwardRef(function PasswordInput(
  { className = "", testIdPrefix = "password", ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={visible ? "text" : "password"}
        className={`pr-11 ${className}`}
        data-testid={`${testIdPrefix}-input`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-md text-slate-400 transition hover:bg-slate-800/60 hover:text-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400"
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        data-testid={`${testIdPrefix}-toggle-visibility`}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
